import z from 'zod';

import { reportError } from '../sentry.ts';

import { BaseOptionsSchema, FormSubmitHandler } from './types.ts';

const DataSchema = z.record(z.string(), z.unknown());

const OptionsSchema = BaseOptionsSchema.extend({
    url: z.string().nonempty(),
});

type Data = z.infer<typeof DataSchema>;
type Options = z.infer<typeof OptionsSchema>;

async function handle(
    data: Record<string, unknown>,
    options: Record<string, unknown>,
) {
    const { url, errorMessage, successMessage } = OptionsSchema.parse(options);

    let response;
    try {
        response = await fetch(url, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
    } catch (err) {
        throw new Error(errorMessage, {
            cause: err,
        });
    }

    if (!response.ok) {
        if (response.status >= 500) {
            reportError(
                new Error(
                    `Google sheets form request failed: ${response.status}`,
                ),
                {
                    url,
                    status: response.status,
                },
            );
        }

        throw new Error(errorMessage);
    }

    return successMessage;
}

export default {
    dataSchema: DataSchema,
    optionsSchema: OptionsSchema,
    handle,
} satisfies FormSubmitHandler<Data, Options>;
